import { useEffect, useRef, useState } from "react";

function usePlAnimationWrapperVisibleObserver(observerOptions: IntersectionObserverInit = {}) {
    const {
        root,
        rootMargin,
        threshold = 1,
    } = observerOptions;
    const [isElementVisible, setIsElementVisible] = useState(false);

    const elementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const currentElement = elementRef.current;
        const observer = new IntersectionObserver(([entry]) => {
            setIsElementVisible(entry.isIntersecting);
        }, {
            root,
            rootMargin,
            threshold,
        });

        if (currentElement) {
            observer.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, [root, rootMargin, threshold]);

    return { isElementVisible, elementRef };
}

export default usePlAnimationWrapperVisibleObserver;
